<form class="filter" #formElement [formGroup]="form"> 
  <mat-form-field class="full-width">
    <input type="number" matInput placeholder="Documento" formControlName="Number">
  </mat-form-field>
  <mat-form-field class="full-width">
    <input type="text" matInput placeholder="Apellido" formControlName="LastName">
  </mat-form-field>
  <mat-form-field class="full-width">
    <input type="text" matInput placeholder="Nombre" formControlName="FirstName">
  </mat-form-field>
  <mat-checkbox formControlName="Deleted">Ver deshabilitados</mat-checkbox> 
</form>